import { supabase } from "./supabase";

export async function fetchServiceOrderMessageSummaries(serviceOrderIds, userId) {
  const ids = Array.from(new Set((serviceOrderIds || []).filter(Boolean)));
  const empty = Object.fromEntries(
    ids.map((id) => [id, { messageCount: 0, unreadCount: 0, lastMessageAt: null }])
  );
  if (!ids.length) return empty;

  const { data: messages, error } = await supabase
    .from("service_order_messages")
    .select("id, service_order_id, author_id, created_at")
    .in("service_order_id", ids)
    .order("created_at", { ascending: true });
  if (error) {
    // Permite desplegar el frontend antes de aplicar la migración sin dejar
    // inaccesibles las pantallas de Ingresos u Operaciones.
    if (error.code === "42P01" || /service_order_messages/i.test(error.message || "")) {
      console.warn("[service-order-messages] La migración de mensajes todavía no está aplicada.");
      return empty;
    }
    throw error;
  }

  const messageIds = (messages || []).map((row) => row.id);
  let readIds = new Set();
  if (userId && messageIds.length) {
    const { data: reads, error: readError } = await supabase
      .from("service_order_message_reads")
      .select("message_id")
      .eq("user_id", userId)
      .in("message_id", messageIds);
    if (readError) throw readError;
    readIds = new Set((reads || []).map((row) => row.message_id));
  }

  for (const message of messages || []) {
    const summary = empty[message.service_order_id];
    if (!summary) continue;
    summary.messageCount += 1;
    summary.lastMessageAt = message.created_at;
    if (userId && message.author_id !== userId && !readIds.has(message.id)) {
      summary.unreadCount += 1;
    }
  }
  return empty;
}
